import { useEffect, useState } from "react";
import axios from 'axios'

import '../Dashboard.css'
import PhoneLoader from "../components/loader/PhoneLoader"
import Footer from "../components/Footer"

function SelectBranch({ fallbackSedes = [] }) {
    const [sedes, setSedes] = useState(fallbackSedes);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const url = `${process.env.REACT_APP_API}/register/get-sedes`;
                const token = localStorage.getItem("token");

                const queryGetSedes = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const responseData = queryGetSedes.data.data;
                // console.log(responseData);
                if (mounted && Array.isArray(responseData)) setSedes(responseData);
            } catch {
                // usa fallbackSedes
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        return () => { mounted = false; };
    }, []);


    const onPick = async (id) => {
        console.log(id);
        await axios.post(process.env.REACT_APP_API + "/context/sede", { sedeId: id });
        // Redirige a la sección que prefieras (Registro, Créditos, etc.)
        window.location.assign("/evaluation-system");
    };

    if (loading) return null;

    return (
        <div>
            {loading && (<PhoneLoader />)}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={process.env.REACT_APP_URL + '/logo-movilespay.png'} alt="Movilpro Logo" className="logo" />
            </div>
            <div className="blockBody blockSelectBranch" style={{ marginTop: 0 }}>

                <h3>Selecciónar Sede</h3>
                <div className="parentCard">
                    {
                        sedes && sedes.map((sede, index) => (
                            <div key={index} className="card" onClick={() => onPick(sede.idNumber)}>
                                <img
                                    src={"https://placehold.co/600x400?text=Tienda MP"}
                                    alt={sede.sedeLocation}
                                />
                                <div className="card-content">
                                    <h3>{sede.sede}</h3>
                                    <p>
                                        {sede.sedeLocation}
                                    </p>
                                </div>
                            </div>
                        )).reverse()
                    }
                </div>

            </div>

            <Footer />
        </div>
    );
}

export default SelectBranch;
